import type { Organization } from '../../types/organization.types';

/** The From name and address on the org's outbound email, as configured for eAlert campaigns. */
export function orgEmailSender(
  organization: Organization | null | undefined,
  fallbackEmail = '',
): { name: string; email: string } {
  return {
    name:
      organization?.sendgrid_reply_to_name ||
      organization?.assistant_name ||
      organization?.org_name ||
      'Remi',
    email:
      organization?.sendgrid_sender_email ||
      organization?.sendgrid_reply_to_email ||
      organization?.reply_to_email ||
      fallbackEmail,
  };
}
